import Dropdown from "react-multilevel-dropdown";
import { GetAllRolesDTO } from "../../api-client-nswag/taxportal-client";
import { useState } from "react";
import "./NestedDropDown.css";
interface NestedDropDownTypes {
  rolesData: GetAllRolesDTO[];
  provideAccess: boolean;
  handleRoleClick: any;
  handleClick: any;
  handleClickApp: any;
  handleExternalUser: any;
  handleThirdPartyUser: any;
  handleMemberFirmUser:any;
  appName: string;
  handleTESSForIsClick: () => void;
  handleTESSIsheet: () => void;
  handleIURClick: any;
  handleTESSClick: any;
}
const NestedDropDown = ({
  rolesData,
  provideAccess,
  handleRoleClick,
  handleClick,
  handleClickApp,
  handleExternalUser,
  handleThirdPartyUser,
  handleMemberFirmUser,
  appName,
  handleTESSForIsClick,
  handleTESSIsheet,
  handleIURClick,
  handleTESSClick,
}: NestedDropDownTypes) => {
  const externalUserOptions = ["External User", "Check Status"];
  const thirdPartyOptions = ["Third-Party User", "Check Status"];
  const memberFirmOptions = ["Member Firm User", "Check Status"];
  return (
    <div>
      {appName === "IS" ? (
        <Dropdown
          isDisabled={provideAccess}
          title="RUN"
          buttonVariant="tertiary"
        >
          <Dropdown.Item onClick={handleTESSForIsClick}>
            TESS Internal User Isheet
          </Dropdown.Item>
          <Dropdown.Item onClick={handleTESSIsheet}>TESS Isheet</Dropdown.Item>
        </Dropdown>
      ) : (
        <Dropdown title="RUN" buttonVariant="tertiary">
          <Dropdown.Item>
            <div style={{ color: provideAccess ? "lightgray" : "black" }}>
              Provide Access
            </div>
            {!provideAccess && (
              <Dropdown.Submenu>
                <Dropdown.Item onClick={handleIURClick}>
                  <div style={{ color: provideAccess ? "lightgray" : "black" }}>
                    Internal User Isheet
                  </div>
                </Dropdown.Item>
                {appName === "TP" && (
                  <>
                    <Dropdown.Item onClick={handleTESSClick}>
                      <div style={{ color: provideAccess ? "lightgray" : "black" }}>
                        TESS
                      </div>
                    </Dropdown.Item>
                    <Dropdown.Item>
                      <div style={{ color: "black" }}>Application</div>
                      <Dropdown.Submenu>
                        <Dropdown.Item onClick={() => handleClickApp("TESS")}>TESS</Dropdown.Item>
                      </Dropdown.Submenu>
                    </Dropdown.Item>
                  </>
                )}
              </Dropdown.Submenu>
            )}
          </Dropdown.Item>
          <Dropdown.Item onClick={handleClick}>
            <div style={{ color: provideAccess ? "lightgray" : "black" }}>
              Content Admin
            </div>
          </Dropdown.Item>
          <Dropdown.Item onClick={handleIURClick}>
            <div style={{ color: provideAccess ? "lightgray" : "black" }}>
              Internal User Isheet
            </div>
          </Dropdown.Item>
          <Dropdown.Item onClick={handleTESSClick}>
            <div style={{ color: provideAccess ? "lightgray" : "black" }}>
              TESS
            </div>
          </Dropdown.Item>
          <Dropdown.Item>
            <div style={{ color: provideAccess ? "lightgray" : "black" }}>
              External User
            </div>
            {!provideAccess && (
              <Dropdown.Submenu>
                {externalUserOptions.map((e) => {
                  return (
                    <Dropdown.Item key={e} onClick={() => handleExternalUser(e)}>
                      {e}
                    </Dropdown.Item>
                  );
                })}
              </Dropdown.Submenu>
            )}
          </Dropdown.Item>
          <Dropdown.Item>
            <div style={{ color: provideAccess ? "lightgray" : "black" }}>
              Third-Party User
            </div>
            {!provideAccess && (
              <Dropdown.Submenu>
                {thirdPartyOptions.map((e) => {
                  return (
                    <Dropdown.Item key={e} onClick={() => handleThirdPartyUser(e)}>
                      {e}
                    </Dropdown.Item>
                  );
                })}
              </Dropdown.Submenu>
            )}
          </Dropdown.Item>
          {appName === "CS" && (
            <Dropdown.Item>
              <div style={{ color: provideAccess ? "lightgray" : "black" }}>
                Member Firm User
              </div>

              {!provideAccess && (
                <Dropdown.Submenu>
                  {memberFirmOptions.map((e) => {
                    return (
                      <Dropdown.Item key={e} onClick={() => handleMemberFirmUser(e)}>
                        {e}
                      </Dropdown.Item>
                    );
                  })}
                </Dropdown.Submenu>
              )}
            </Dropdown.Item>
          )}
        </Dropdown>
      )}
    </div>
  );
};

export default NestedDropDown;
